import { render } from "./PlansThankyou.vue?vue&type=template&id=3f441d95"
import script from "./PlansThankyou.vue?vue&type=script&lang=js"
export * from "./PlansThankyou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__